import type { BaseTierId } from "@/lib/quiz/types"

/**
 * Whether a quiz result shows the membership-vs-one-off side-by-side. Only
 * blood-test recommendations (`blood_only`) on CH (where Ahead membership is
 * sold) get it; MRI tiers and non-CH results fall back to the single
 * recommendation card.
 *
 * This shipped as the winner of the `quiz-result-membership` experiment
 * (concluded on `membership-default`) — it used to be the flag's mount gate;
 * it is now the permanent layout gate.
 */
export function isQuizMembershipEligible(
  baseTier: BaseTierId,
  country: string
): boolean {
  return baseTier === "blood_only" && country === "ch"
}
